export const parseActivity = (isActive) => {
  if (isActive)
    return "deactivate";
  return "activate";
}